import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { DashboardTabs } from '../dashboard/DashboardTabs';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';

export function DashboardLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const showDashboardTabs = location.pathname.startsWith('/dashboard');

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar menuOpen={menuOpen} onToggleMenu={() => setMenuOpen(!menuOpen)} />

      <div className="mx-auto flex max-w-[1600px] flex-col lg:flex-row">
        <div className={`${menuOpen ? 'block' : 'hidden'} lg:block`}>
          <Sidebar />
        </div>
        <main className="min-w-0 flex-1">
          {showDashboardTabs ? <DashboardTabs /> : null}
          <div className="p-4 lg:p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
